module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    portizOrange: '#eb8231',
                    portizYellow: '#ffa939',
                    portizBlue: '#133D4D',
                    portizGreenBlue: '#006774',
                    portizAquaBlue: '#2E8995',
                    portizBlueish: '#005f76'
                }
            },
        },
        fontFamily: {
            poppins: ['Poppins', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
